'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormatIcon = require('./FormatIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormatIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/FormatIcon/index.js
// module id = 835
// module chunks = 9 10